import axiosInstance from '../../utils/axiosInstance';
const API_URL = process.env.REACT_APP_API_CUSTOMER;

export const submitCreateForm = async (formData) => {
  const response = await axiosInstance.post(API_URL, formData);
  return response.data;
};

export const getCustomers = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

export const getActiveCustomers = async () => {
  const response = await axiosInstance.get(`${API_URL}/active`);
  return response.data;
};

export const createCustomer = async (customer) => {
  const response = await axiosInstance.post(API_URL, customer);
  return response.data;
};

export const updateCustomer = async (id, customer) => {
  const response = await axiosInstance.put(`${API_URL}/${id}`, customer);
  return response.data;
};

export const deleteCustomer = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

export const markUserInactive = async (id, date) => {
  const response = await axiosInstance.put(`${API_URL}/mark-inactive/${id}`, {date});
  return response.data;
}

export const getCustomerById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/${id}`);
  return response.data;
};

export const createCustomerTeamMember = async (customerTeam) => {
  const response = await axiosInstance.post(`${API_URL}/team`, customerTeam);
  return response.data;
};

export const updateCustomerTeamMember = async (id, customerTeam) => {
  const response = await axiosInstance.put(`${API_URL}/team/${id}`, customerTeam);
  return response.data;
};

export const markCustomerTeamMemberInactive = async (id, date, customer_id) => {
  const response = await axiosInstance.put(`${API_URL}/team/mark-inactive/${id}`, {date, customer_id});
  return response.data;
}

export const createBulkCustomers = async (customer) => {
  const response = await axiosInstance.post(`${API_URL}/import`, customer);
  return response.data;
};
